export const SvgClock = ({ color }) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6005_5512"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="15"
      >
        <rect y="0.5" width="14" height="14" fill={color} />
      </mask>
      <g mask="url(#mask0_6005_5512)">
        <path
          d="M9.02593 10.1407L9.64076 9.52584L7.43751 7.32259V4.58325H6.56251V7.67711L9.02593 10.1407ZM7.00103 13.0416C6.23453 13.0416 5.51407 12.8961 4.83963 12.6053C4.1652 12.3144 3.57857 11.9196 3.07972 11.4209C2.58087 10.9223 2.18591 10.3359 1.89482 9.66175C1.60384 8.98761 1.45834 8.26734 1.45834 7.50094C1.45834 6.73444 1.60379 6.01397 1.89468 5.33954C2.18557 4.66511 2.58034 4.07847 3.07899 3.57963C3.57764 3.08078 4.16404 2.68581 4.83818 2.39473C5.51232 2.10374 6.23259 1.95825 6.99899 1.95825C7.76549 1.95825 8.48595 2.1037 9.16039 2.39459C9.83482 2.68547 10.4215 3.08025 10.9203 3.5789C11.4191 4.07755 11.8141 4.66395 12.1052 5.33809C12.3962 6.01222 12.5417 6.73249 12.5417 7.4989C12.5417 8.2654 12.3962 8.98586 12.1053 9.66029C11.8145 10.3347 11.4197 10.9214 10.921 11.4202C10.4224 11.9191 9.83598 12.314 9.16184 12.6051C8.4877 12.8961 7.76743 13.0416 7.00103 13.0416ZM7.00001 12.1666C8.29307 12.1666 9.39411 11.7121 10.3031 10.803C11.2122 9.89402 11.6667 8.79297 11.6667 7.49992C11.6667 6.20686 11.2122 5.10582 10.3031 4.19679C9.39411 3.28777 8.29307 2.83325 7.00001 2.83325C5.70695 2.83325 4.60591 3.28777 3.69689 4.19679C2.78786 5.10582 2.33334 6.20686 2.33334 7.49992C2.33334 8.79297 2.78786 9.89402 3.69689 10.803C4.60591 11.7121 5.70695 12.1666 7.00001 12.1666Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const SvgLocation = ({ width, height, style }) => {
  return (
    <svg
      width={width ? width : "14"}
      height={height ? height : "15"}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <mask
        id="mask0_6005_5517"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="15"
      >
        <rect y="0.5" width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6005_5517)">
        <path
          d="M7.00125 7.42131C7.29146 7.42131 7.53957 7.31797 7.74558 7.11127C7.95169 6.90458 8.05475 6.65613 8.05475 6.36592C8.05475 6.07571 7.9514 5.82755 7.74471 5.62144C7.53801 5.41543 7.28951 5.31242 6.99921 5.31242C6.709 5.31242 6.46089 5.41577 6.25487 5.62246C6.04876 5.82915 5.94571 6.07765 5.94571 6.36796C5.94571 6.65817 6.04906 6.90628 6.25575 7.11229C6.46244 7.31831 6.71094 7.42131 7.00125 7.42131ZM7.00023 11.8828C8.14142 10.8612 9.01472 9.88128 9.62012 8.94309C10.2255 8.00489 10.5282 7.18317 10.5282 6.47792C10.5282 5.4145 10.1904 4.54028 9.51469 3.85525C8.83899 3.17022 8.00084 2.82771 7.00023 2.82771C5.99962 2.82771 5.16146 3.17022 4.48577 3.85525C3.81008 4.54028 3.47223 5.4145 3.47223 6.47792C3.47223 7.18317 3.77493 8.00489 4.38033 8.94309C4.98574 9.88128 5.85903 10.8612 7.00023 11.8828ZM7.00023 13.0471C5.53217 11.7751 4.43133 10.5912 3.69769 9.49565C2.96405 8.39995 2.59723 7.39404 2.59723 6.47792C2.59723 5.13178 3.03264 4.04197 3.90346 3.20848C4.77437 2.37499 5.80663 1.95825 7.00023 1.95825C8.19383 1.95825 9.22608 2.37499 10.097 3.20848C10.9678 4.04197 11.4032 5.13178 11.4032 6.47792C11.4032 7.39404 11.0364 8.39995 10.3028 9.49565C9.56913 10.5912 8.46828 11.7751 7.00023 13.0471Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export const SvgDownload = ({ color }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6005_5339"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="18"
      >
        <rect x="0.5" width="18" height="18" fill={color} />
      </mask>
      <g mask="url(#mask0_6005_5339)">
        <path
          d="M9.5 11.5586C9.40963 11.5586 9.3255 11.5442 9.24763 11.5153C9.16975 11.4866 9.09569 11.4371 9.02544 11.3668L6.69331 9.03469C6.58181 8.92306 6.52675 8.7925 6.52813 8.643C6.52963 8.4935 6.58469 8.36056 6.69331 8.24419C6.80969 8.12794 6.94331 8.06788 7.09419 8.064C7.24519 8.06013 7.37887 8.11638 7.49525 8.23275L8.9375 9.675V3.9375C8.9375 3.77788 8.99137 3.64425 9.09912 3.53662C9.20675 3.42887 9.34037 3.375 9.5 3.375C9.65963 3.375 9.79325 3.42887 9.90088 3.53662C10.0086 3.64425 10.0625 3.77788 10.0625 3.9375V9.675L11.5047 8.23275C11.6164 8.12125 11.7488 8.06619 11.9021 8.06756C12.0554 8.06906 12.1903 8.12794 12.3067 8.24419C12.4153 8.36056 12.4716 8.49231 12.4754 8.63944C12.4793 8.78656 12.4231 8.91831 12.3067 9.03469L9.97456 11.3668C9.90431 11.4371 9.83025 11.4866 9.75237 11.5153C9.6745 11.5442 9.59037 11.5586 9.5 11.5586ZM5.23081 14.625C4.85194 14.625 4.53125 14.4938 4.26875 14.2313C4.00625 13.9688 3.875 13.6481 3.875 13.2692V11.7981C3.875 11.6384 3.92887 11.5048 4.03662 11.3972C4.14425 11.2894 4.27788 11.2356 4.4375 11.2356C4.59712 11.2356 4.73075 11.2894 4.83838 11.3972C4.94613 11.5048 5 11.6384 5 11.7981V13.2692C5 13.3269 5.02406 13.3798 5.07219 13.4278C5.12019 13.4759 5.17306 13.5 5.23081 13.5H13.7692C13.8269 13.5 13.8798 13.4759 13.9278 13.4278C13.9759 13.3798 14 13.3269 14 13.2692V11.7981C14 11.6384 14.0539 11.5048 14.1616 11.3972C14.2692 11.2894 14.4029 11.2356 14.5625 11.2356C14.7221 11.2356 14.8558 11.2894 14.9634 11.3972C15.0711 11.5048 15.125 11.6384 15.125 11.7981V13.2692C15.125 13.6481 14.9938 13.9688 14.7313 14.2313C14.4688 14.4938 14.1481 14.625 13.7692 14.625H5.23081Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const SvgWhatsapp = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1055 4.39153C13.5065 3.7897 12.7931 3.31251 12.0069 2.98777C11.2207 2.66303 10.3774 2.49723 9.52613 2.50004C5.9593 2.50004 3.05226 5.39253 3.05226 8.94152C3.05226 10.079 3.35276 11.184 3.91457 12.159L3 15.5L6.42965 14.603C7.37688 15.1165 8.44171 15.3895 9.52613 15.3895C13.093 15.3895 16 12.497 16 8.94802C16 7.22552 15.3271 5.60703 14.1055 4.39153ZM9.52613 14.2975C8.5593 14.2975 7.61206 14.0375 6.78241 13.55L6.58643 13.433L4.54824 13.966L5.09045 11.99L4.9598 11.7885C4.42252 10.9351 4.13729 9.94854 4.13668 8.94152C4.13668 5.99053 6.55377 3.58553 9.5196 3.58553C10.9568 3.58553 12.309 4.14453 13.3216 5.15853C13.8231 5.65504 14.2205 6.24568 14.4907 6.89619C14.761 7.5467 14.8987 8.24412 14.896 8.94802C14.909 11.899 12.492 14.2975 9.52613 14.2975ZM12.4789 10.2935C12.3156 10.2155 11.5186 9.82552 11.3749 9.76702C11.2246 9.71502 11.1201 9.68902 11.009 9.84502C10.898 10.0075 10.591 10.3715 10.4995 10.4755C10.408 10.586 10.31 10.599 10.1467 10.5145C9.98342 10.4365 9.4608 10.261 8.84673 9.71502C8.36332 9.28602 8.04322 8.75952 7.94523 8.59702C7.85377 8.43452 7.93216 8.35002 8.01709 8.26552C8.08894 8.19402 8.1804 8.07702 8.25879 7.98602C8.33719 7.89502 8.36985 7.82352 8.42211 7.71952C8.47437 7.60902 8.44824 7.51802 8.40904 7.44002C8.36985 7.36202 8.04322 6.56902 7.91256 6.24402C7.78191 5.93203 7.64472 5.97103 7.54673 5.96453H7.23317C7.12211 5.96453 6.95226 6.00353 6.80201 6.16603C6.65829 6.32852 6.2402 6.71852 6.2402 7.51152C6.2402 8.30452 6.82161 9.07152 6.9 9.17552C6.97839 9.28602 8.04322 10.911 9.66332 11.6065C10.0487 11.7755 10.3492 11.873 10.5844 11.9445C10.9698 12.068 11.3226 12.0485 11.6035 12.0095C11.9171 11.964 12.5638 11.6195 12.6945 11.2425C12.8317 10.8655 12.8317 10.547 12.7859 10.4755C12.7402 10.404 12.6422 10.3715 12.4789 10.2935Z"
        fill={color}
      />
    </svg>
  );
};

export const SvgEmail = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6005_5409"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="18"
      >
        <rect x="0.5" width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6005_5409)">
        <path
          d="M3.73081 14.625C3.35194 14.625 3.03125 14.4938 2.76875 14.2313C2.50625 13.9688 2.375 13.6481 2.375 13.2692V4.73081C2.375 4.35194 2.50625 4.03125 2.76875 3.76875C3.03125 3.50625 3.35194 3.375 3.73081 3.375H15.2692C15.6481 3.375 15.9688 3.50625 16.2313 3.76875C16.4938 4.03125 16.625 4.35194 16.625 4.73081V13.2692C16.625 13.6481 16.4938 13.9688 16.2313 14.2313C15.9688 14.4938 15.6481 14.625 15.2692 14.625H3.73081ZM15.5 5.58169L9.86487 9.189C9.80725 9.22162 9.74762 9.24731 9.686 9.26606C9.6245 9.28481 9.5625 9.29419 9.5 9.29419C9.4375 9.29419 9.3755 9.28481 9.314 9.26606C9.25238 9.24731 9.19275 9.22162 9.13513 9.189L3.5 5.58169V13.2692C3.5 13.3366 3.52163 13.3919 3.56488 13.4351C3.60813 13.4784 3.66344 13.5 3.73081 13.5H15.2692C15.3366 13.5 15.3919 13.4784 15.4351 13.4351C15.4784 13.3919 15.5 13.3366 15.5 13.2692V5.58169ZM9.5 8.25L15.3847 4.5H3.61531L9.5 8.25ZM3.5 5.75475V4.89731V4.91963V4.89581V5.75475Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export const SvgPrint = ({ color }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6005_5383"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="18"
      >
        <rect x="0.5" width="18" height="18" fill={color} />
      </mask>
      <g mask="url(#mask0_6005_5383)">
        <path
          d="M6.73081 15.3749C6.35793 15.3749 6.03874 15.2422 5.77324 14.9767C5.50774 14.7112 5.37499 14.392 5.37499 14.0191V12.3749H3.94718C3.57431 12.3749 3.25512 12.2422 2.98962 11.9767C2.72412 11.7112 2.59137 11.392 2.59137 11.0191V8.10571C2.59137 7.57446 2.77287 7.12915 3.13587 6.76978C3.49887 6.4104 3.94237 6.23071 4.46637 6.23071H14.5336C15.0649 6.23071 15.5102 6.4104 15.8696 6.76978C16.2289 7.12915 16.4086 7.57446 16.4086 8.10571V11.0191C16.4086 11.392 16.2759 11.7112 16.0104 11.9767C15.7449 12.2422 15.4257 12.3749 15.0528 12.3749H13.625V14.0191C13.625 14.392 13.4922 14.7112 13.2267 14.9767C12.9612 15.2422 12.6421 15.3749 12.2692 15.3749H6.73081ZM3.94718 11.2499H5.37499C5.38462 10.8855 5.52074 10.5733 5.78337 10.3132C6.04612 10.053 6.36193 9.92296 6.73081 9.92296H12.2692C12.6381 9.92296 12.9538 10.053 13.2164 10.3132C13.4792 10.5733 13.6154 10.8855 13.625 11.2499H15.0528C15.1202 11.2499 15.1755 11.2283 15.2187 11.185C15.262 11.1418 15.2836 11.0865 15.2836 11.0191V8.10571C15.2836 7.89321 15.2117 7.71509 15.068 7.57134C14.9242 7.42759 14.7461 7.35571 14.5336 7.35571H4.46637C4.25387 7.35571 4.07574 7.42759 3.93199 7.57134C3.78824 7.71509 3.71637 7.89321 3.71637 8.10571V11.0191C3.71637 11.0865 3.73799 11.1418 3.78124 11.185C3.82449 11.2283 3.87981 11.2499 3.94718 11.2499ZM12.5 6.23071V4.21153C12.5 4.14415 12.4784 4.08884 12.4351 4.04559C12.3919 4.00234 12.3366 3.98071 12.2692 3.98071H6.73081C6.66343 3.98071 6.60812 4.00234 6.56487 4.04559C6.52162 4.08884 6.49999 4.14415 6.49999 4.21153V6.23071H5.37499V4.21153C5.37499 3.83865 5.50774 3.51946 5.77324 3.25396C6.03874 2.98846 6.35793 2.85571 6.73081 2.85571H12.2692C12.6421 2.85571 12.9612 2.98846 13.2267 3.25396C13.4922 3.51946 13.625 3.83865 13.625 4.21153V6.23071H12.5ZM13.8558 9.23071C14.0683 9.23071 14.2464 9.15884 14.3902 9.01509C14.5339 8.87134 14.6058 8.69321 14.6058 8.48071C14.6058 8.26821 14.5339 8.09009 14.3902 7.94634C14.2464 7.80259 14.0683 7.73071 13.8558 7.73071C13.6433 7.73071 13.4652 7.80259 13.3214 7.94634C13.1777 8.09009 13.1058 8.26821 13.1058 8.48071C13.1058 8.69321 13.1777 8.87134 13.3214 9.01509C13.4652 9.15884 13.6433 9.23071 13.8558 9.23071ZM12.5 14.0191V11.2788C12.5 11.2114 12.4784 11.1561 12.4351 11.1128C12.3919 11.0696 12.3366 11.048 12.2692 11.048H6.73081C6.66343 11.048 6.60812 11.0696 6.56487 11.1128C6.52162 11.1561 6.49999 11.2114 6.49999 11.2788V14.0191C6.49999 14.0865 6.52162 14.1418 6.56487 14.185C6.60812 14.2283 6.66343 14.2499 6.73081 14.2499H12.2692C12.3366 14.2499 12.3919 14.2283 12.4351 14.185C12.4784 14.1418 12.5 14.0865 12.5 14.0191Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const SvgAccordion = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5990_7508"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect
          y="18"
          width="18"
          height="18"
          transform="rotate(-90 0 18)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_5990_7508)">
        <path
          d="M8.99977 11.1113L14.6493 5.4617C14.7983 5.3127 14.9738 5.24008 15.1756 5.24383C15.3776 5.2477 15.5531 5.32414 15.7021 5.47314C15.8511 5.62227 15.9256 5.79777 15.9256 5.99964C15.9256 6.20152 15.8511 6.37702 15.7021 6.52614L9.96033 12.2794C9.8247 12.415 9.67277 12.5155 9.50452 12.5809C9.33627 12.6463 9.16802 12.679 8.99977 12.679C8.83152 12.679 8.66327 12.6463 8.49502 12.5809C8.32677 12.5155 8.17483 12.415 8.0392 12.2794L2.28577 6.52614C2.13677 6.37702 2.0642 6.19958 2.06808 5.99383C2.07195 5.78808 2.14839 5.6107 2.29739 5.4617C2.44639 5.3127 2.62189 5.2382 2.82389 5.2382C3.02577 5.2382 3.2012 5.3127 3.3502 5.4617L8.99977 11.1113Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export const CrossWithBorder = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect x="0.5" y="0.5" width="19" height="19" stroke="#333333" />
      <mask
        id="mask0_6093_9114"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="16"
        height="16"
      >
        <rect x="2.5" y="2.5" width="15" height="15" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6093_9114)">
        <path
          d="M6.50039 14.1585L5.8418 13.4999L9.3418 9.9999L5.8418 6.4999L6.50039 5.84131L10.0004 9.34131L13.5004 5.84131L14.159 6.4999L10.659 9.9999L14.159 13.4999L13.5004 14.1585L10.0004 10.6585L6.50039 14.1585Z"
          fill="#333333"
        />
      </g>
    </svg>
  );
};

export const SvgCamera = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 16 15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 11.625C8.9375 11.625 9.73438 11.2969 10.3906 10.6406C11.0469 9.98438 11.375 9.1875 11.375 8.25C11.375 7.3125 11.0469 6.51562 10.3906 5.85938C9.73438 5.20312 8.9375 4.875 8 4.875C7.0625 4.875 6.26562 5.20312 5.60938 5.85938C4.95312 6.51562 4.625 7.3125 4.625 8.25C4.625 9.1875 4.95312 9.98438 5.60938 10.6406C6.26562 11.2969 7.0625 11.625 8 11.625ZM8 10.125C7.475 10.125 7.03125 9.94375 6.66875 9.58125C6.30625 9.21875 6.125 8.775 6.125 8.25C6.125 7.725 6.30625 7.28125 6.66875 6.91875C7.03125 6.55625 7.475 6.375 8 6.375C8.525 6.375 8.96875 6.55625 9.33125 6.91875C9.69375 7.28125 9.875 7.725 9.875 8.25C9.875 8.775 9.69375 9.21875 9.33125 9.58125C8.96875 9.94375 8.525 10.125 8 10.125ZM2 14.25C1.5875 14.25 1.23438 14.1031 0.940625 13.8094C0.646875 13.5156 0.5 13.1625 0.5 12.75V3.75C0.5 3.3375 0.646875 2.98438 0.940625 2.69063C1.23438 2.39688 1.5875 2.25 2 2.25H4.3625L5.75 0.75H10.25L11.6375 2.25H14C14.4125 2.25 14.7656 2.39688 15.0594 2.69063C15.3531 2.98438 15.5 3.3375 15.5 3.75V12.75C15.5 13.1625 15.3531 13.5156 15.0594 13.8094C14.7656 14.1031 14.4125 14.25 14 14.25H2ZM2 12.75H14V3.75H10.9625L9.59375 2.25H6.40625L5.0375 3.75H2V12.75Z" />
    </svg>
  );
};

export const SvgCalender = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none" style={{ margin: '0' }}>
      <mask id="mask0_6093_7420" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="18">
        <rect x="0.166626" width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6093_7420)">
        <path d="M6.16663 10.4567C5.983 10.4567 5.8265 10.3921 5.69713 10.2628C5.56788 10.1334 5.50325 9.97695 5.50325 9.79332C5.50325 9.6097 5.56788 9.4532 5.69713 9.32382C5.8265 9.19445 5.983 9.12976 6.16663 9.12976C6.35025 9.12976 6.50675 9.19445 6.63613 9.32382C6.76538 9.4532 6.83 9.6097 6.83 9.79332C6.83 9.97695 6.76538 10.1334 6.63613 10.2628C6.50675 10.3921 6.35025 10.4567 6.16663 10.4567ZM9.16663 10.4567C8.983 10.4567 8.8265 10.3921 8.69713 10.2628C8.56788 10.1334 8.50325 9.97695 8.50325 9.79332C8.50325 9.6097 8.56788 9.4532 8.69713 9.32382C8.8265 9.19445 8.983 9.12976 9.16663 9.12976C9.35025 9.12976 9.50675 9.19445 9.63613 9.32382C9.76538 9.4532 9.83 9.6097 9.83 9.79332C9.83 9.97695 9.76538 10.1334 9.63613 10.2628C9.50675 10.3921 9.35025 10.4567 9.16663 10.4567ZM12.1666 10.4567C11.983 10.4567 11.8265 10.3921 11.6971 10.2628C11.5679 10.1334 11.5033 9.97695 11.5033 9.79332C11.5033 9.6097 11.5679 9.4532 11.6971 9.32382C11.8265 9.19445 11.983 9.12976 12.1666 9.12976C12.3503 9.12976 12.5068 9.19445 12.6361 9.32382C12.7654 9.4532 12.83 9.6097 12.83 9.79332C12.83 9.97695 12.7654 10.1334 12.6361 10.2628C12.5068 10.3921 12.3503 10.4567 12.1666 10.4567ZM4.14744 16.125C3.76856 16.125 3.44788 15.9938 3.18538 15.7313C2.92288 15.4688 2.79163 15.1481 2.79163 14.7692V4.73082C2.79163 4.35195 2.92288 4.03126 3.18538 3.76876C3.44788 3.50626 3.76856 3.37501 4.14744 3.37501H5.18581V1.78857H6.33969V3.37501H12.0224V1.78857H13.1474V3.37501H14.1858C14.5647 3.37501 14.8854 3.50626 15.1479 3.76876C15.4104 4.03126 15.5416 4.35195 15.5416 4.73082V14.7692C15.5416 15.1481 15.4104 15.4688 15.1479 15.7313C14.8854 15.9938 14.5647 16.125 14.1858 16.125H4.14744ZM4.14744 15H14.1858C14.2436 15 14.2964 14.976 14.3444 14.9278C14.3926 14.8798 14.4166 14.827 14.4166 14.7692V7.73082H3.91663V14.7692C3.91663 14.827 3.94069 14.8798 3.98881 14.9278C4.03681 14.976 4.08969 15 4.14744 15ZM3.91663 6.60582H14.4166V4.73082C14.4166 4.67307 14.3926 4.6202 14.3444 4.5722C14.2964 4.52407 14.2436 4.50001 14.1858 4.50001H4.14744C4.08969 4.50001 4.03681 4.52407 3.98881 4.5722C3.94069 4.6202 3.91663 4.67307 3.91663 4.73082V6.60582Z" fill="#333333" />
      </g>
    </svg>
  );
};
export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
    >
      <path
        d="M12.6315 12.3816C11.945 12.3816 11.3647 12.1446 10.8906 11.6705C10.4166 11.1965 10.1796 10.6162 10.1796 9.92969C10.1796 9.24303 10.4166 8.66268 10.8906 8.18865C11.3647 7.71462 11.945 7.47761 12.6315 7.47761C13.318 7.47761 13.8983 7.71462 14.3723 8.18865C14.8463 8.66268 15.0834 9.24303 15.0834 9.92969C15.0834 10.6162 14.8463 11.1965 14.3723 11.6705C13.8983 12.1446 13.318 12.3816 12.6315 12.3816ZM12.6298 11.5482C13.0763 11.5482 13.458 11.3904 13.7748 11.0747C14.0916 10.759 14.25 10.3778 14.25 9.93115C14.25 9.48462 14.0922 9.10296 13.7765 8.78615C13.4608 8.46935 13.0797 8.31094 12.6331 8.31094C12.1865 8.31094 11.8047 8.46879 11.4879 8.78448C11.1713 9.10018 11.0129 9.48136 11.0129 9.92803C11.0129 10.3746 11.1708 10.7562 11.4865 11.073C11.8022 11.3898 12.1833 11.5482 12.6298 11.5482ZM7.77565 10.3464H2.58335C2.4653 10.3464 2.36634 10.3064 2.28648 10.2264C2.20662 10.1464 2.16669 10.0473 2.16669 9.92907C2.16669 9.81087 2.20662 9.71199 2.28648 9.6324C2.36634 9.55282 2.4653 9.51303 2.58335 9.51303H7.77565C7.8937 9.51303 7.99266 9.55296 8.07252 9.63282C8.15238 9.71282 8.19231 9.81192 8.19231 9.93011C8.19231 10.0483 8.15238 10.1472 8.07252 10.2268C7.99266 10.3065 7.8937 10.3464 7.77565 10.3464ZM3.36856 5.52261C2.68203 5.52261 2.10176 5.2856 1.62773 4.81157C1.1537 4.33754 0.916687 3.75719 0.916687 3.07053C0.916687 2.384 1.1537 1.80372 1.62773 1.32969C2.10176 0.855666 2.68203 0.618652 3.36856 0.618652C4.05509 0.618652 4.63537 0.855666 5.1094 1.32969C5.58342 1.80372 5.82044 2.384 5.82044 3.07053C5.82044 3.75719 5.58342 4.33754 5.1094 4.81157C4.63537 5.2856 4.05509 5.52261 3.36856 5.52261ZM3.3669 4.68928C3.81356 4.68928 4.1953 4.53143 4.5121 4.21573C4.82877 3.90004 4.9871 3.51886 4.9871 3.07219C4.9871 2.62567 4.82926 2.244 4.51356 1.92719C4.19787 1.61039 3.81676 1.45199 3.37023 1.45199C2.9237 1.45199 2.54203 1.60983 2.22523 1.92553C1.90842 2.24122 1.75002 2.6224 1.75002 3.06907C1.75002 3.5156 1.90787 3.89726 2.22356 4.21407C2.53926 4.53087 2.92037 4.68928 3.3669 4.68928ZM13.4167 3.48719H8.2244C8.10634 3.48719 8.00738 3.44726 7.92752 3.3674C7.84766 3.2874 7.80773 3.1883 7.80773 3.07011C7.80773 2.95192 7.84766 2.85303 7.92752 2.77344C8.00738 2.69372 8.10634 2.65386 8.2244 2.65386H13.4167C13.5347 2.65386 13.6337 2.69386 13.7136 2.77386C13.7934 2.85386 13.8334 2.95296 13.8334 3.07115C13.8334 3.18935 13.7934 3.28824 13.7136 3.36782C13.6337 3.4474 13.5347 3.48719 13.4167 3.48719Z"
        fill="#1C1B1F"
      />
    </svg>
  );
};

export const SvgNext = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5983_8314"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="17"
      >
        <rect x="0.5" y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5983_8314)">
        <path
          d="M11.2837 9.16674H3.83366C3.64477 9.16674 3.48644 9.10285 3.35866 8.97507C3.23088 8.8473 3.16699 8.68896 3.16699 8.50007C3.16699 8.31118 3.23088 8.15285 3.35866 8.02507C3.48644 7.89729 3.64477 7.83341 3.83366 7.83341H11.2837L8.01699 4.56674C7.88366 4.43341 7.81977 4.27785 7.82533 4.10007C7.83088 3.9223 7.90033 3.76674 8.03366 3.63341C8.16699 3.51118 8.32255 3.4473 8.50033 3.44174C8.6781 3.43618 8.83366 3.50007 8.96699 3.63341L13.367 8.03341C13.4337 8.10007 13.4809 8.1723 13.5087 8.25007C13.5364 8.32785 13.5503 8.41118 13.5503 8.50007C13.5503 8.58896 13.5364 8.6723 13.5087 8.75007C13.4809 8.82785 13.4337 8.90007 13.367 8.96674L8.96699 13.3667C8.84477 13.489 8.69199 13.5501 8.50866 13.5501C8.32533 13.5501 8.16699 13.489 8.03366 13.3667C7.90033 13.2334 7.83366 13.0751 7.83366 12.8917C7.83366 12.7084 7.90033 12.5501 8.03366 12.4167L11.2837 9.16674Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const SvgSearch = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.2852 15.1477L9.05125 9.91351C8.63459 10.2575 8.15542 10.5268 7.61375 10.7212C7.07209 10.9157 6.51174 11.0129 5.93271 11.0129C4.50841 11.0129 3.30299 10.5198 2.31646 9.53351C1.32993 8.54726 0.83667 7.34212 0.83667 5.91809C0.83667 4.4942 1.32979 3.28865 2.31604 2.30143C3.30229 1.31434 4.50743 0.820801 5.93146 0.820801C7.35535 0.820801 8.56091 1.31406 9.54813 2.30059C10.5352 3.28712 11.0288 4.49254 11.0288 5.91684C11.0288 6.51198 10.9289 7.08038 10.7292 7.62205C10.5293 8.16372 10.2627 8.63483 9.92938 9.03539L15.1633 14.2693L14.2852 15.1477ZM5.93271 9.76309C7.00646 9.76309 7.91591 9.39045 8.66105 8.64518C9.40632 7.90004 9.77896 6.99059 9.77896 5.91684C9.77896 4.84309 9.40632 3.93365 8.66105 3.18851C7.91591 2.44323 7.00646 2.07059 5.93271 2.07059C4.85896 2.07059 3.94952 2.44323 3.20438 3.18851C2.4591 3.93365 2.08646 4.84309 2.08646 5.91684C2.08646 6.99059 2.4591 7.90004 3.20438 8.64518C3.94952 9.39045 4.85896 9.76309 5.93271 9.76309Z"
        fill="#1C1B1F"
      />
    </svg>
  );
};
export const SvgRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="12"
      viewBox="0 0 17 12"
      fill="black"
    >
      <g clipPath="url(#clip0_6093_5578)">
        <path
          d="M16.5488 5.27416C12.5086 4.76301 11.0605 0.540892 11.0395 0.5L10.0426 0.816914C10.0951 0.980483 11.1235 3.97584 13.9253 5.48885H0V6.51115H13.9253C11.134 8.02416 10.0951 11.0297 10.0426 11.1831L11.0395 11.5C11.0395 11.5 12.5086 7.23699 16.5488 6.72584L17.0105 6.6645V5.32528L16.5488 5.26394V5.27416Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_6093_5578">
          <rect
            width="17"
            height="11"
            fill="black"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SvgMan = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="mask0_6562_9534"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6562_9534)">
        <path
          d="M10 9.70521C9.10167 9.70521 8.33268 9.37697 7.69303 8.7205C7.05323 8.06387 6.73333 7.27457 6.73333 6.35261C6.73333 5.43064 7.05323 4.64142 7.69303 3.98495C8.33268 3.32832 9.10167 3 10 3C10.8983 3 11.6673 3.32832 12.307 3.98495C12.9468 4.64142 13.2667 5.43064 13.2667 6.35261C13.2667 7.27457 12.9468 8.06387 12.307 8.7205C11.6673 9.37697 10.8983 9.70521 10 9.70521ZM3 17V14.8704C3 14.4013 3.12413 13.9669 3.3724 13.5672C3.62067 13.1674 3.95247 12.8601 4.3678 12.6452C5.29024 12.1811 6.22086 11.833 7.15963 11.6009C8.09841 11.3687 9.0452 11.2527 10 11.2527C10.9548 11.2527 11.9016 11.3687 12.8404 11.6009C13.7791 11.833 14.7098 12.1811 15.6322 12.6452C16.0475 12.8601 16.3793 13.1674 16.6276 13.5672C16.8759 13.9669 17 14.4013 17 14.8704V17H3ZM4.4 15.5632H15.6V14.8704C15.6 14.6764 15.5452 14.4968 15.4357 14.3316C15.3262 14.1665 15.1776 14.0317 14.9898 13.9273C14.1856 13.5209 13.3657 13.2129 12.53 13.0035C11.6942 12.7942 10.8509 12.6895 10 12.6895C9.14911 12.6895 8.30577 12.7942 7.46997 13.0035C6.63432 13.2129 5.81439 13.5209 5.01017 13.9273C4.82241 14.0317 4.67378 14.1665 4.56427 14.3316C4.45476 14.4968 4.4 14.6764 4.4 14.8704V15.5632ZM10 8.26838C10.5133 8.26838 10.9528 8.08079 11.3183 7.70562C11.6839 7.33045 11.8667 6.87944 11.8667 6.35261C11.8667 5.82577 11.6839 5.37476 11.3183 4.99959C10.9528 4.62442 10.5133 4.43683 10 4.43683C9.48667 4.43683 9.04722 4.62442 8.68167 4.99959C8.31611 5.37476 8.13333 5.82577 8.13333 6.35261C8.13333 6.87944 8.31611 7.33045 8.68167 7.70562C9.04722 8.08079 9.48667 8.26838 10 8.26838Z"
          fill="#333333"
        />
      </g>
    </svg>
  );
};
export const SvgPlusCircle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="mask0_6537_7718"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6537_7718)">
        <path
          d="M9.58333 13.75H10.4167V10.4167H13.75V9.58333H10.4167V6.25H9.58333V9.58333H6.25V10.4167H9.58333V13.75ZM10.0027 17.5C8.96562 17.5 7.99056 17.3032 7.0775 16.9096C6.16458 16.516 5.37042 15.9818 4.695 15.3071C4.01958 14.6324 3.48493 13.8389 3.09104 12.9267C2.69701 12.0146 2.5 11.0399 2.5 10.0027C2.5 8.96562 2.69681 7.99056 3.09042 7.0775C3.48403 6.16458 4.01819 5.37042 4.69292 4.695C5.36764 4.01958 6.16111 3.48493 7.07333 3.09104C7.98542 2.69701 8.96007 2.5 9.99729 2.5C11.0344 2.5 12.0094 2.69681 12.9225 3.09042C13.8354 3.48403 14.6296 4.01819 15.305 4.69292C15.9804 5.36764 16.5151 6.16111 16.909 7.07333C17.303 7.98542 17.5 8.96007 17.5 9.99729C17.5 11.0344 17.3032 12.0094 16.9096 12.9225C16.516 13.8354 15.9818 14.6296 15.3071 15.305C14.6324 15.9804 13.8389 16.5151 12.9267 16.909C12.0146 17.303 11.0399 17.5 10.0027 17.5ZM10 16.6667C11.8611 16.6667 13.4375 16.0208 14.7292 14.7292C16.0208 13.4375 16.6667 11.8611 16.6667 10C16.6667 8.13889 16.0208 6.5625 14.7292 5.27083C13.4375 3.97917 11.8611 3.33333 10 3.33333C8.13889 3.33333 6.5625 3.97917 5.27083 5.27083C3.97917 6.5625 3.33333 8.13889 3.33333 10C3.33333 11.8611 3.97917 13.4375 5.27083 14.7292C6.5625 16.0208 8.13889 16.6667 10 16.6667Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
export const SvgMap = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M9.50016 13.6025L4.50016 11.8525L1.20204 13.1281C0.988427 13.2073 0.790232 13.1841 0.607454 13.0585C0.424815 12.9329 0.333496 12.7564 0.333496 12.5287V2.33642C0.333496 2.18795 0.369538 2.05232 0.441621 1.92954C0.513704 1.80663 0.618704 1.72114 0.756621 1.67309L4.50016 0.397461L9.50016 2.14746L12.7983 0.871835C13.0119 0.792668 13.2101 0.807877 13.3929 0.91746C13.5755 1.0269 13.6668 1.1901 13.6668 1.40704V11.7275C13.6668 11.8866 13.6227 12.025 13.5345 12.1427C13.4465 12.2602 13.3282 12.3429 13.1797 12.391L9.50016 13.6025ZM9.0835 12.5864V2.83642L4.91683 1.38142V11.1314L9.0835 12.5864ZM9.91683 12.5864L12.8335 11.625V1.74996L9.91683 2.83642V12.5864ZM1.16683 12.25L4.0835 11.1314V1.38142L1.16683 2.37496V12.25Z"
        fill="#1C1B1F"
      />
    </svg>
  );
};
export const SvgWatch = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="mask0_6562_12569"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6562_12569)">
        <path
          d="M13.0385 13.6281L13.6281 13.0385L10.4167 9.82646V5.83333H9.58333V10.1731L13.0385 13.6281ZM10.0027 17.5C8.96562 17.5 7.99056 17.3032 7.0775 16.9096C6.16458 16.516 5.37042 15.9818 4.695 15.3071C4.01958 14.6324 3.48493 13.8389 3.09104 12.9267C2.69701 12.0146 2.5 11.0399 2.5 10.0027C2.5 8.96562 2.69681 7.99056 3.09042 7.0775C3.48403 6.16458 4.01819 5.37042 4.69292 4.695C5.36764 4.01958 6.16111 3.48493 7.07333 3.09104C7.98542 2.69701 8.96007 2.5 9.99729 2.5C11.0344 2.5 12.0094 2.69681 12.9225 3.09042C13.8354 3.48403 14.6296 4.01819 15.305 4.69292C15.9804 5.36764 16.5151 6.16111 16.909 7.07333C17.303 7.98542 17.5 8.96007 17.5 9.99729C17.5 11.0344 17.3032 12.0094 16.9096 12.9225C16.516 13.8354 15.9818 14.6296 15.3071 15.305C14.6324 15.9804 13.8389 16.5151 12.9267 16.909C12.0146 17.303 11.0399 17.5 10.0027 17.5ZM10 16.6667C11.8472 16.6667 13.4201 16.0174 14.7188 14.7188C16.0174 13.4201 16.6667 11.8472 16.6667 10C16.6667 8.15278 16.0174 6.57986 14.7188 5.28125C13.4201 3.98264 11.8472 3.33333 10 3.33333C8.15278 3.33333 6.57986 3.98264 5.28125 5.28125C3.98264 6.57986 3.33333 8.15278 3.33333 10C3.33333 11.8472 3.98264 13.4201 5.28125 14.7188C6.57986 16.0174 8.15278 16.6667 10 16.6667Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
export const SvgLuggage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <mask
        id="mask0_6780_3100"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6780_3100)">
        <path
          d="M5.5962 15C5.26308 15 4.97789 14.8814 4.74064 14.6441C4.50339 14.4069 4.38477 14.1216 4.38477 13.7884V6C4.38477 5.66687 4.50339 5.38169 4.74064 5.14444C4.97789 4.90706 5.26308 4.78838 5.5962 4.78838H7.2117V3.46162C7.2117 3.12837 7.33033 2.84312 7.56758 2.60587C7.80483 2.36862 8.09002 2.25 8.42314 2.25H9.57701C9.91014 2.25 10.1953 2.36862 10.4326 2.60587C10.6698 2.84312 10.7885 3.12837 10.7885 3.46162V4.78838H12.404C12.7371 4.78838 13.0223 4.90706 13.2595 5.14444C13.4968 5.38169 13.6154 5.66687 13.6154 6V13.7884C13.6154 14.1216 13.4968 14.4069 13.2595 14.6441C13.0223 14.8814 12.7371 15 12.404 15V15.1731C12.404 15.3279 12.3465 15.4628 12.2316 15.5777C12.1166 15.6926 11.9818 15.75 11.827 15.75C11.6721 15.75 11.5373 15.6926 11.4224 15.5777C11.3075 15.4628 11.2501 15.3279 11.2501 15.1731V15H6.75008V15.1731C6.75008 15.3279 6.69264 15.4628 6.57777 15.5777C6.46289 15.6926 6.32802 15.75 6.17314 15.75C6.01839 15.75 5.88352 15.6926 5.76852 15.5777C5.65364 15.4628 5.5962 15.3279 5.5962 15.1731V15ZM5.5962 14.25H12.404C12.5386 14.25 12.6491 14.2068 12.7356 14.1203C12.8221 14.0336 12.8654 13.923 12.8654 13.7884V6C12.8654 5.86538 12.8221 5.75481 12.7356 5.66831C12.6491 5.58169 12.5386 5.53837 12.404 5.53837H5.5962C5.46158 5.53837 5.35102 5.58169 5.26452 5.66831C5.17802 5.75481 5.13477 5.86538 5.13477 6V13.7884C5.13477 13.923 5.17802 14.0336 5.26452 14.1203C5.35102 14.2068 5.46158 14.25 5.5962 14.25ZM7.58614 6.86531C7.47977 6.86531 7.39077 6.90125 7.31914 6.97313C7.24752 7.045 7.2117 7.13406 7.2117 7.24031V12.5481C7.2117 12.6543 7.24764 12.7434 7.31952 12.8153C7.39152 12.8871 7.4807 12.9231 7.58708 12.9231C7.69345 12.9231 7.78245 12.8871 7.85408 12.8153C7.92583 12.7434 7.9617 12.6543 7.9617 12.5481V7.24031C7.9617 7.13406 7.9257 7.045 7.8537 6.97313C7.7817 6.90125 7.69252 6.86531 7.58614 6.86531ZM10.4131 6.86531C10.3067 6.86531 10.2177 6.90125 10.1461 6.97313C10.0743 7.045 10.0385 7.13406 10.0385 7.24031V12.5481C10.0385 12.6543 10.0745 12.7434 10.1465 12.8153C10.2185 12.8871 10.3076 12.9231 10.414 12.9231C10.5204 12.9231 10.6094 12.8871 10.681 12.8153C10.7526 12.7434 10.7885 12.6543 10.7885 12.5481V7.24031C10.7885 7.13406 10.7525 7.045 10.6806 6.97313C10.6086 6.90125 10.5195 6.86531 10.4131 6.86531ZM7.9617 4.78838H10.0385V3.46162C10.0385 3.327 9.9952 3.21637 9.9087 3.12975C9.8222 3.04325 9.71164 3 9.57701 3H8.42314C8.28852 3 8.17795 3.04325 8.09145 3.12975C8.00495 3.21637 7.9617 3.327 7.9617 3.46162V4.78838Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
export const SvgTick = ({ style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
    >
      <path
        d="M3.36651 6.34365L9.12551 0.58465C9.22462 0.485428 9.34062 0.434761 9.47351 0.43265C9.6064 0.430539 9.72456 0.481205 9.82801 0.58465C9.93145 0.688094 9.98317 0.806872 9.98317 0.940983C9.98317 1.07521 9.93145 1.19404 9.82801 1.29748L3.78834 7.34748C3.66779 7.46793 3.52717 7.52815 3.36651 7.52815C3.20584 7.52815 3.06523 7.46793 2.94467 7.34748L0.161342 4.56415C0.0622306 4.46493 0.0133417 4.34715 0.014675 4.21082C0.0158972 4.07459 0.0682305 3.95476 0.171675 3.85132C0.275119 3.74787 0.393897 3.69615 0.528008 3.69615C0.662231 3.69615 0.781064 3.74787 0.884508 3.85132L3.36651 6.34365Z"
        fill="white"
      />
    </svg>
  );
};

export const SvgHotelItenarary = ({ style }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
      <mask id="mask0_8081_6380" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="15">
        <rect x="0.280273" y="0.390015" width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8081_6380)">
        <path d="M2.54624 12.3933C2.30027 12.3933 2.09109 12.3071 1.91872 12.1347C1.74634 11.9622 1.66016 11.753 1.66016 11.507V3.07102C1.66016 2.82505 1.74634 2.61587 1.91872 2.4435C2.09109 2.27112 2.30027 2.18494 2.54624 2.18494H6.31559C6.56157 2.18494 6.77074 2.27112 6.94311 2.4435C7.11549 2.61587 7.20168 2.82505 7.20168 3.07102V4.51827H12.0143C12.2603 4.51827 12.4695 4.60446 12.6418 4.77683C12.8142 4.94921 12.9004 5.15838 12.9004 5.40435V11.507C12.9004 11.753 12.8142 11.9622 12.6418 12.1347C12.4695 12.3071 12.2603 12.3933 12.0143 12.3933H2.54624ZM2.53501 11.5183H6.32682V10.0599H2.53501V11.5183ZM2.53501 9.18494H6.32682V7.7266H2.53501V9.18494ZM2.53501 6.8516H6.32682V5.39327H2.53501V6.8516ZM2.53501 4.51827H6.32682V3.05994H2.53501V4.51827ZM7.20168 11.5183H12.0256V5.39327H7.20168V11.5183ZM8.91814 7.7266C8.79418 7.7266 8.69025 7.68465 8.60634 7.60075C8.52254 7.51685 8.48064 7.41287 8.48064 7.28881C8.48064 7.16485 8.52254 7.06097 8.60634 6.97717C8.69025 6.89346 8.79418 6.8516 8.91814 6.8516H10.1969C10.3209 6.8516 10.4248 6.89355 10.5086 6.97746C10.5925 7.06126 10.6344 7.16519 10.6344 7.28925C10.6344 7.4133 10.5925 7.51719 10.5086 7.60089C10.4248 7.6847 10.3209 7.7266 10.1969 7.7266H8.91814ZM8.91814 10.0599C8.79418 10.0599 8.69025 10.018 8.60634 9.93408C8.52254 9.85018 8.48064 9.7462 8.48064 9.62215C8.48064 9.49819 8.52254 9.39431 8.60634 9.3105C8.69025 9.22679 8.79418 9.18494 8.91814 9.18494H10.1969C10.3209 9.18494 10.4248 9.22689 10.5086 9.31079C10.5925 9.3946 10.6344 9.49853 10.6344 9.62258C10.6344 9.74664 10.5925 9.85052 10.5086 9.93423C10.4248 10.018 10.3209 10.0599 10.1969 10.0599H8.91814Z" fill="#333333" />
      </g>
    </svg>
  );
};


export const SvgHotelCategory = ({ style }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <mask id="mask0_8081_6434" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="13">
        <rect y="0.890015" width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8081_6434)">
        <path d="M4.125 9.70726L6 8.27851L7.875 9.70726L7.17312 7.38614L9.04325 6.05739H6.75188L6 3.62076L5.24813 6.05739H2.95675L4.82687 7.38614L4.125 9.70726ZM6.00087 11.64C5.34387 11.64 4.72633 11.5153 4.14825 11.266C3.57017 11.0167 3.06733 10.6783 2.63975 10.2509C2.21217 9.82347 1.87362 9.32085 1.62412 8.74301C1.37471 8.16518 1.25 7.54781 1.25 6.89089C1.25 6.23389 1.37467 5.61635 1.624 5.03826C1.87333 4.46018 2.21171 3.95735 2.63913 3.52976C3.06654 3.10218 3.56917 2.76364 4.147 2.51414C4.72483 2.26472 5.34221 2.14001 5.99913 2.14001C6.65613 2.14001 7.27367 2.26468 7.85175 2.51401C8.42983 2.76335 8.93267 3.10172 9.36025 3.52914C9.78783 3.95656 10.1264 4.45918 10.3759 5.03701C10.6253 5.61485 10.75 6.23222 10.75 6.88914C10.75 7.54614 10.6253 8.16368 10.376 8.74177C10.1267 9.31985 9.78829 9.82268 9.36088 10.2503C8.93346 10.6778 8.43083 11.0164 7.853 11.2659C7.27517 11.5153 6.65779 11.64 6.00087 11.64Z" fill="#ECB119" />
      </g>
    </svg>
  );
};

export const SvgCallItenarary = ({ style }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <mask id="mask0_8081_6617" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8081_6617)">
        <path d="M12.9603 13.6666C11.704 13.6666 10.4418 13.3745 9.17383 12.7903C7.90594 12.206 6.741 11.3819 5.679 10.3179C4.61711 9.25381 3.79405 8.08881 3.20983 6.82292C2.62561 5.55714 2.3335 4.29609 2.3335 3.03975C2.3335 2.83786 2.40016 2.66964 2.5335 2.53509C2.66683 2.40053 2.8335 2.33325 3.0335 2.33325H5.20783C5.37616 2.33325 5.52466 2.3882 5.65333 2.49809C5.782 2.60786 5.86383 2.74353 5.89883 2.90509L6.281 4.86659C6.30744 5.04859 6.30188 5.20497 6.26433 5.33575C6.22666 5.46653 6.15911 5.57636 6.06166 5.66525L4.522 7.16408C4.76977 7.61786 5.05288 8.04714 5.37133 8.45192C5.68966 8.85659 6.03433 9.24309 6.40533 9.61142C6.77111 9.97731 7.16 10.3171 7.572 10.6308C7.984 10.9444 8.42888 11.2363 8.90666 11.5064L10.4027 9.99742C10.507 9.88886 10.6333 9.81275 10.7817 9.76908C10.9299 9.72553 11.0839 9.71486 11.2438 9.73708L13.095 10.1141C13.2633 10.1585 13.4007 10.2444 13.5072 10.3718C13.6136 10.4991 13.6668 10.6435 13.6668 10.8051V12.9666C13.6668 13.1666 13.5996 13.3333 13.465 13.4666C13.3304 13.5999 13.1622 13.6666 12.9603 13.6666ZM4.04883 6.21792L5.23866 5.07942C5.26 5.06231 5.27388 5.03881 5.28033 5.00892C5.28677 4.97903 5.28572 4.95125 5.27716 4.92558L4.98733 3.43575C4.97877 3.40164 4.96383 3.37603 4.9425 3.35892C4.92116 3.34181 4.89338 3.33325 4.85916 3.33325H3.4335C3.40783 3.33325 3.38644 3.34181 3.36933 3.35892C3.35233 3.37603 3.34383 3.39742 3.34383 3.42309C3.37794 3.87864 3.4525 4.34142 3.5675 4.81142C3.68238 5.28153 3.84283 5.75036 4.04883 6.21792ZM9.84883 11.9794C10.2907 12.1854 10.7516 12.3429 11.2315 12.4519C11.7115 12.5608 12.16 12.6255 12.577 12.6461C12.6027 12.6461 12.6241 12.6375 12.6412 12.6204C12.6583 12.6033 12.6668 12.5819 12.6668 12.5563V11.1538C12.6668 11.1195 12.6583 11.0918 12.6412 11.0704C12.6241 11.0491 12.5984 11.0341 12.5643 11.0256L11.1643 10.7409C11.1387 10.7324 11.1162 10.7313 11.097 10.7378C11.0778 10.7442 11.0574 10.7581 11.036 10.7794L9.84883 11.9794Z" fill="#333333" />
      </g>
    </svg>
  );
};

export const SvgMailItenarary = ({ style }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <mask id="mask0_8081_6622" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8081_6622)">
        <path d="M2.87216 13C2.53538 13 2.25033 12.8833 2.01699 12.65C1.78366 12.4167 1.66699 12.1316 1.66699 11.7948V4.20517C1.66699 3.86839 1.78366 3.58333 2.01699 3.35C2.25033 3.11667 2.53538 3 2.87216 3H13.1285C13.4653 3 13.7503 3.11667 13.9837 3.35C14.217 3.58333 14.3337 3.86839 14.3337 4.20517V11.7948C14.3337 12.1316 14.217 12.4167 13.9837 12.65C13.7503 12.8833 13.4653 13 13.1285 13H2.87216ZM8.00033 8.37183L2.66699 4.9615V11.7948C2.66699 11.8547 2.68621 11.9039 2.72466 11.9423C2.7631 11.9808 2.81227 12 2.87216 12H13.1285C13.1884 12 13.2375 11.9808 13.276 11.9423C13.3144 11.9039 13.3337 11.8547 13.3337 11.7948V4.9615L8.00033 8.37183ZM8.00033 7.33333L13.2312 4H2.76949L8.00033 7.33333ZM2.66699 4.9615V4V11.7948C2.66699 11.8547 2.68621 11.9039 2.72466 11.9423C2.7631 11.9808 2.81227 12 2.87216 12H2.66699V4.9615Z" fill="#333333" />
      </g>
    </svg>

  );
};

export const SvgLocationItenarary = ({ style }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <mask id="mask0_8081_6262" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
        <rect width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8081_6262)">
        <path d="M6.00095 5.9325C6.2497 5.9325 6.46237 5.84392 6.63895 5.66675C6.81562 5.48959 6.90395 5.27663 6.90395 5.02788C6.90395 4.77913 6.81537 4.56642 6.6382 4.38975C6.46103 4.21317 6.24803 4.12488 5.9992 4.12488C5.75045 4.12488 5.53778 4.21346 5.3612 4.39063C5.18453 4.56779 5.0962 4.78079 5.0962 5.02963C5.0962 5.27838 5.18478 5.49104 5.36195 5.66763C5.53912 5.84421 5.75212 5.9325 6.00095 5.9325ZM6.00007 9.75663C6.97824 8.88096 7.72678 8.04104 8.2457 7.23688C8.76462 6.43271 9.02407 5.72838 9.02407 5.12388C9.02407 4.21238 8.73449 3.46304 8.15532 2.87588C7.57616 2.28871 6.85774 1.99513 6.00007 1.99513C5.14241 1.99513 4.42399 2.28871 3.84482 2.87588C3.26566 3.46304 2.97607 4.21238 2.97607 5.12388C2.97607 5.72838 3.23553 6.43271 3.75445 7.23688C4.27337 8.04104 5.02191 8.88096 6.00007 9.75663ZM6.00007 10.7546C4.74174 9.6643 3.79816 8.64959 3.16932 7.7105C2.54049 6.77134 2.22607 5.90913 2.22607 5.12388C2.22607 3.97004 2.59928 3.03592 3.3457 2.3215C4.0922 1.60709 4.97699 1.24988 6.00007 1.24988C7.02316 1.24988 7.90795 1.60709 8.65445 2.3215C9.40087 3.03592 9.77407 3.97004 9.77407 5.12388C9.77407 5.90913 9.45966 6.77134 8.83082 7.7105C8.20199 8.64959 7.25841 9.6643 6.00007 10.7546Z" fill="white" />
      </g>
    </svg>
  );
};


